import React from "react";
import styles from "./PeopleUI.module.css";

export default function EmptyContact({ employee, onAddContactInfo, variant }) {
  // variant: 'link' for contractor add-contact link, 'muted' for plain "No contact info"
  const isContractor = employee?.kind === "ghost";
  const showLink = variant === "link" || (isContractor && onAddContactInfo);

  if (showLink) {
    return (
      <button
        type="button"
        className={styles.emptyContactLink}
        onClick={(e) => {
          e.stopPropagation();
          onAddContactInfo?.(employee);
        }}
      >
        + Add contact info
      </button>
    );
  }

  return <span className={styles.emptyContactMuted}>No contact info</span>;
}
